export const SET_PAGE = "SET_PAGE";
export const setPage = page => ({ type: SET_PAGE, page });
export const setPageHome = () => ({ type: SET_PAGE, page: "" });

export const SET_PAGE_FROM_HISTORY = "SET_PAGE_FROM_HISTORY";
export const setPageFromHistory = page => ({
  type: SET_PAGE_FROM_HISTORY,
  page
});



// WEBPACK FOOTER //
// ./src/redux/actions/page.js